import type { Service } from '../../graphqlEnums'

import { bluesky } from './services/bluesky'
import { facebook } from './services/facebook'
import { googlebusiness } from './services/googlebusiness'
import { instagram } from './services/instagram'
import { linkedin } from './services/linkedin'
import { mastodon } from './services/mastodon'
import { pinterest } from './services/pinterest'
import { startPage } from './services/startPage'
import { substack } from './services/substack'
import { threads } from './services/threads'
import { tiktok } from './services/tiktok'
import { twitter } from './services/twitter'
import { youtube } from './services/youtube'
import { notImplementedEntry } from './types'
import type { ServiceMapperEntry } from './types'

export type { MetadataMapper, ServiceMapperEntry } from './types'
export { NotImplemented } from './types'

// One entry per `Service`. A service with a composer declares its mapper in
// its own `services/<service>.ts` file. The `Record<Service, …>` makes this
// exhaustive: adding a `Service` to the schema without a registration fails the
// build here. Such a PR only edits its own service file, so multiple network
// PRs never conflict on this registry.
export const serviceRegistry: Record<Service, ServiceMapperEntry> = {
  startPage,
  instagram,
  facebook,
  googlebusiness,
  linkedin,
  threads,
  tiktok,
  twitter,
  youtube,
  mastodon,
  pinterest,
  bluesky,
  substack,
  // WhatsApp is a direct-message channel with no composer.
  whatsapp: notImplementedEntry('whatsapp'),
}

// The registry is keyed by every `Service`, so membership narrows a profile's
// `serviceName` (typed `string`) to `Service`.
export const isService = (value: string): value is Service =>
  value in serviceRegistry
